import React from 'react';
import classNames from 'classnames';
import styles from '../../styles/layout.module.css';

// Usage: Pass col-*, col-md-*, col-sm-* classes to children for responsive spans
export default function Grid({ columns = 1, children, className }) {
  const gridClass = styles[`grid${columns}`] || styles.grid12;
  return <div className={classNames(styles.grid, gridClass, className)}>{children}</div>;
} 